import { getCases } from '@/app/api';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICases } from '@/pages/cases/types';

interface IIntialState {
  allCases: ICases[];
  data: ICases[];
  lastUpdated: string;
  isOpen: boolean;
  loading: boolean;
}

const initialState: IIntialState = {
  allCases: [],
  data: [],
  lastUpdated: '',
  isOpen: false,
  loading: false,
};

export const fetchCases = createAsyncThunk(
  'cases/fetchCases',
  async (_, { rejectWithValue }) => {
    try {
      const res = await getCases();
      if (res) {
        const date = new Date(res.lastUpdated);
        return {
          data: res.data,
          lastUpdated: `${date.toLocaleDateString()} | ${date.toLocaleTimeString(
            _ as undefined,
            {
              hour: '2-digit',
              minute: '2-digit',
            }
          )}`,
        };
      }
      return { lastUpdated: 'N/A' };
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const casesSlice = createSlice({
  name: 'cases',
  initialState,
  reducers: {
    setChangeIsOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
      state.data = state.allCases.filter(
        (caseItem) => caseItem.isOpen !== state.isOpen
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCases.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCases.fulfilled, (state, action) => {
        state.loading = false;
        state.allCases = action.payload.data;
        state.data = action.payload.data.filter(
          (caseItem) => caseItem.isOpen !== state.isOpen
        );
        state.lastUpdated = action.payload.lastUpdated;
      })
      .addCase(fetchCases.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setChangeIsOpen } = casesSlice.actions;
export default casesSlice.reducer;
